import type BaseHttpService from "../../client/BaseHttpService";
import type { ApiResponse } from "../../client/types";
import type { GradeResultsResponseData, RemoteGradingData, RemoteGradingResponseData } from "./types";

export * from "./types";

export class GraderApi {
	private static readonly BASE_PATH = "/api/v1";

	constructor(private readonly http: BaseHttpService) {}

	async submitRemoteGrading(data: RemoteGradingData, options?: RequestInit): Promise<RemoteGradingResponseData> {
		const response = await this.http.post<ApiResponse<RemoteGradingResponseData>>(
			"Submitting remote grading request",
			`${GraderApi.BASE_PATH}/grade-request`,
			data,
			{ "content-type": "application/json" },
			options,
		);
		return response.data;
	}

	async getGradeResponse(id: string, options?: RequestInit): Promise<GradeResultsResponseData> {
		const response = await this.http.get<ApiResponse<GradeResultsResponseData>>(
			"Polling grader database for grade response",
			`${GraderApi.BASE_PATH}/get-grade-response-by-id?id=${id}`,
			undefined,
			options,
		);
		return response.data;
	}
}
